import Base from './base';

import Quantity from './quantity';
import Favorite from './favorite';
import Loyalty from './loyalty';
import Toast from './toast';

import './component.scss';

export class SaleBasketBasketPage extends Base {
    constructor(id, params, result, options) {
        super(id, params, result, options)
        if (this.$component.classList.contains('is-basket-inited')) {
            return;
        }
        this.$component.classList.add('is-basket-inited')
        this.init()
    }

    init() {
        this.render()
        this.initModules()
        this.addObservers()
    }

    render() {
        this.renderProductList()
        this.renderLoyalty()
        this.renderPromo()
        this.renderTotal()
        this.afterRendered()
    }

    reInit() {
        this.reInitModules()
    }

    afterRendered() {
        BX.onCustomEvent(window, 'sale.basket.basket.rendered')
    }

    addObservers() {
        let self = this

        /**
         * Test button for refresh basket
         */
        this.$component.on('click', '.js-basket-refresh', async () => {
            await self.refresh()
            BX.onCustomEvent(`OnBasketChange`)
        })

        /**
         * Product -> variant
         */
        this.$component.on('click', '.js-basket-variant', async function (e) {
            await self.changeItemVariant(this)
            BX.onCustomEvent(`OnBasketChange`)
        })

        this.$component.on('click', '.js-basket-variant-open', function (e) {
            self.variantCollapse(this)
        })

        document.addEventListener('click', function (event) {
            for (let dropdown of document.querySelectorAll('.js-basket-variant-dropdown.is-open')) {
                const isClickInside = dropdown.contains(event.target) ||
                    dropdown.closest('.js-basket-variant-block')?.contains(event.target)

                if (!isClickInside) {
                    dropdown.classList.remove('is-open')
                }
            }
        })

        /**
         * Product -> change quantity
         */
        BX.addCustomEvent(window, 'OnQuantityChange', async function () {
            if (this.closest(`#${self.id}`)) {
                await self.changeItemQuantity(this.closest('.js-item'))
                BX.onCustomEvent(`OnBasketChange`)
            }
        })

        /**
         * Product -> remove
         */
        this.$component.on('click', '.js-basket-item-remove', async function (e) {
            await self.removeItem(this.closest('.js-item'))
            BX.onCustomEvent(`OnBasketChange`)
        })

        /**
         * Collapse
         */
        this.$component.on('click', '.js-basket-page__collapse-block__collapse', function (e) {
            self.blockCollapse(this.closest('.js-basket-page__collapse-block'))
        })

        /**
         * Auth & register
         */
        this.$component.on('click', '.js-basket-page__auth', function (e) {
            if (window.toggleWindow) {
                toggleWindow('login-modal-container', 'right');
            }
        })

        this.$component.on('click', '.js-basket-page__register', function (e) {
            if (window.toggleWindow) {
                toggleWindow('register-modal-container', 'right');
            }
        })

        /**
         * Loyalty
         */
        this.$component.on('blur', '.js-basket-page__loyalty__input', async function (e) {
            e.preventDefault();
            await self.applyLoyalty(this.value)
            BX.onCustomEvent(`OnBasketChange`)
        })
        this.$component.on('keyup', '.js-basket-page__loyalty__input', async function (e) {
            if ('Enter' === e.key) {
                await self.applyLoyalty(this.value)
                BX.onCustomEvent(`OnBasketChange`)
            }
        })
        this.$component.on('click', '.js-basket-page__loyalty__max', async function (e) {
            e.preventDefault();
            await self.applyLoyalty(this.dataset.balance)
            BX.onCustomEvent(`OnBasketChange`)
        })

        /**
         * Promocode
         */
        this.$component.on('click', '.js-basket-page__promo__apply', async function (e) {
            e.preventDefault();
            await self.applyCoupon(self.$component.querySelector('.js-basket-page__promo__input').value)
            BX.onCustomEvent(`OnBasketChange`)
        })
        this.$component.on('keyup', '.js-basket-page__promo__input', async function (e) {
            if ('Enter' === e.key) {
                await self.applyCoupon(this.value)
                BX.onCustomEvent(`OnBasketChange`)
            }
        })

        this.$component.on('click', '.js-basket-page__promo__remove', async function (e) {
            e.preventDefault();
            await self.removeCoupon(this.dataset.coupon)
            BX.onCustomEvent(`OnBasketChange`)
        })

        // this.$component.on('click', '.js-basket-go-checkout', () => {
        //     window.location.href = self.params.PATH_TO_ORDER
        // })
    }

    renderProductList() {
        // console.log('renderProductList - start')
        let mustacheId = 'product-list',
            data = {show: true, items: Object.values(this.result.BASKET_ITEM_RENDER_DATA),}
        // console.log('data =', data)
        this.renderMustache(`js-basket-${mustacheId}-template`, `js-basket-${mustacheId}-target`, data)
    }

    renderLoyalty() {
        // console.log('renderLoyalty - start')
        let mustacheId = 'loyalty',
            data = {
                ...{show: true},
                ...this.result.LOYALTY_RENDER_DATA,
            }
        // console.log('data =', data)
        this.renderMustache(`js-basket-${mustacheId}-template`, `js-basket-${mustacheId}-target`, data)
    }

    renderPromo() {
        // console.log('renderPromo - start')
        let mustacheId = 'promo',
            data = {
                ...{show: true},
                ...this.result.PROMO_RENDER_DATA,
            }
        // console.log('data =', data)
        this.renderMustache(`js-basket-${mustacheId}-template`, `js-basket-${mustacheId}-target`, data)
    }

    renderTotal() {
        // console.log('renderTotal - start')
        let mustacheId = 'total',
            data = {
                ...{show: true},
                ...this.result.TOTAL_RENDER_DATA,
            }
        // console.log('data =', data)
        this.renderMustache(`js-basket-${mustacheId}-template`, `js-basket-${mustacheId}-target`, data)
    }

    async changeItemVariant(variant) {
        // console.log('changeItemVariant - start')
        let item = variant.closest('.js-item'),
            basketItemId = item.dataset.id,
            variantBlock = variant.closest('.js-basket-variant-block'),
            postFields = {
                lastAppliedDiscounts: 1
            }

        if (!variantBlock) {
            return
        }

        /**
         * Change visual active variant
         */
        let currentActive = variantBlock.querySelector('.js-basket-variant.active')
        if (currentActive) {
            currentActive.classList.remove('active')
            variant.classList.add('active')
        }

        /**
         * Close dropdown
         */
        let variantDropdown = variant.closest('.js-basket-variant-dropdown')
        if (variantDropdown && true === variantDropdown.classList.contains('is-open')) {
            variantDropdown.classList.remove('is-open')
        }

        /**
         * Fill current visual values (text and pic)
         */
        let textBlockValue = variant.querySelector('.js-basket-variant-text-value'),
            textBlockSelected = variantBlock.querySelector('.js-basket-variant-selected-value'),
            picBlockValue = variant.querySelector('.js-basket-variant-pic'),
            picBlockSelected = variantBlock.querySelector('.js-basket-variant-selected-pic')
        if (textBlockValue && textBlockSelected) {
            textBlockSelected.innerText = textBlockValue.innerText
        }
        if (picBlockValue && picBlockSelected) {
            picBlockSelected.src = picBlockValue.src
        }

        /**
         * Prepare post fields
         */
        for (let row of item.querySelectorAll('.js-basket-variant.active')) {
            let block = row.closest('.js-basket-variant-block')
            let propCode = block.getAttribute('data-prop-code')
            let valueId = row.getAttribute('data-value-id')

            if (basketItemId && propCode && valueId) {
                let fieldName = `basket[OFFER_${basketItemId}][${propCode}]`
                postFields[fieldName] = valueId;
            }
        }

        // console.log('changeItemVariant - variantBlock =', variantBlock)

        const result = await this.query(postFields)
        this.fillResult(result)
        this.render()
        this.reInit()
        this.afterRendered()
    }

    async changeItemQuantity(item) {
        let quantity = item.querySelector('.js-quantity-input').value,
            postFields = {[`basket[QUANTITY_${item.dataset.id}]`]: quantity, lastAppliedDiscounts: 1}
        const result = await this.query(postFields)
        this.fillResult(result)
        this.render()
        this.reInit()
        this.afterRendered()
    }

    async removeItem(item) {
        try {
            let postData = {
                [`basket[DELETE_${item.dataset.id}]`]: 'Y',
                lastAppliedDiscounts: '',
            }
            const result = await this.query(postData)
            if (!result?.BASKET_DATA?.BASKET_ITEMS_COUNT || 0 === Number.parseInt(result?.BASKET_DATA?.BASKET_ITEMS_COUNT)) {
                this.showPreloader()
                BX.reload()
            } else {
                this.fillResult(result)
                this.render()
                this.reInit()
                this.afterRendered()
            }
        } catch (error) {
            console.error(error)
        }
    }

    blockCollapse(parent) {
        parent.classList.toggle('is-show')
    }

    variantCollapse(toggle) {
        let item = toggle.closest('.js-item'),
            block = toggle.closest('.js-basket-variant-block'),
            dropdown = block.querySelector('.js-basket-variant-dropdown')

        if (!block || !dropdown) {
            return
        }

        /**
         * Close other
         */
        for (let row of item.querySelectorAll('.js-basket-variant-dropdown.is-open')) {
            if (row.closest('.js-basket-variant-block').getAttribute('data-prop-code') === block.getAttribute('data-prop-code')) {
                continue
            }

            row.classList.remove('is-open')
        }

        dropdown.classList.toggle('is-open')
    }

    async applyCoupon(coupon) {
        let postFields = {
            [`${this.params.CUSTOM_ACTION_NAME_COUPON}`]: coupon
        }
        let isEmptyCouponPreviously = 0 < this.$component.querySelectorAll('.js-basket-page__promo__input').length

        try {
            const result = await this.query(postFields)

            if (
                true === result.BASKET_DATA?.PROMO_RENDER_DATA?.IS_ERROR
                && '' !== result.BASKET_DATA?.PROMO_RENDER_DATA?.MESSAGE
            ) {
                this.modules.toast.show(result.BASKET_DATA?.PROMO_RENDER_DATA?.MESSAGE, 'error')
            }

            if (
                false === result.BASKET_DATA?.PROMO_RENDER_DATA?.IS_ERROR
                && true === isEmptyCouponPreviously
                && '' !== result.BASKET_DATA?.PROMO_RENDER_DATA?.COUPON
                && '' !== result.BASKET_DATA?.PROMO_RENDER_DATA?.MESSAGE
            ) {
                this.modules.toast.show(result.BASKET_DATA?.PROMO_RENDER_DATA?.MESSAGE)
            }

            this.fillResult(result)
            this.render()
            this.reInit()
            this.afterRendered()
        } catch (error) {
            console.error(error)
        }
    }

    async removeCoupon(coupon) {
        let postFields = {
            [`${this.params.CUSTOM_ACTION_NAME_COUPON_REMOVE}`]: coupon
        }

        try {
            const result = await this.query(postFields)
            this.fillResult(result)
            this.render()
            this.reInit()
            this.afterRendered()
        } catch (error) {
            console.error(error)
        }
    }

    async applyLoyalty(value) {
        let postFields = {
            [`${this.params.CUSTOM_ACTION_NAME_BALANCE}`]: value
        }

        try {
            const result = await this.query(postFields)

            this.fillResult(result)
            this.render()
            this.reInit()
            this.afterRendered()
        } catch (error) {
            console.error(error)
        }
    }

    async refresh() {
        const result = await this.query({lastAppliedDiscounts: 1})

        this.fillResult(result)
        this.render()
        this.reInit()
        this.afterRendered()
    }

    fillResult(result) {
        for (let key in result.BASKET_DATA) {
            this.result[key] = result.BASKET_DATA[key]
        }
    }

    initModules() {
        this.modules = {
            quantity: new Quantity(this.id, this.params, this.result, this.options),
            favorite: new Favorite(this.id, this.params, this.result, this.options),
            loyalty: new Loyalty(this.id, this.params, this.result, this.options),
            toast: new Toast(this.id, this.params, this.result, this.options),
        }
    }

    reInitModules() {
        Object.values(this.modules).forEach(module => {
            if (module && typeof module.reInit === 'function') {
                module.reInit()
            }
        });
    }
}
